import { useState } from 'react';
import Header from './Header';
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";


function Contact() {
    const { register, handleSubmit, formState: { errors, isSubmitted } } = useForm();
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        setLoading(true);
        setStatus(null);
        try {
            const response = await fetch(`${process.env.REACT_APP_GATEWAY}/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            const result = await response.json();
            if (result.success) {
                setStatus('sent');
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error(error);
            setStatus('error');
        }
        setLoading(false);
    };
    

    const openInSameTab = url => {
        window.open(url, '_self', 'noopener,noreferrer');
    };
    
    const navigate = useNavigate();
    
    

    return (
      <div className={"MainW"}>
        <Header bg={true} destination="/" from="about" />
        <div
          className={"mouse2 newbackToGalaxy text-xl"}
          onClick={(e) => openInSameTab("/")}
        >
          {" "}
          [ BACK TO GALAXY ]{" "}
        </div>
        <div className="flex w-svw h-svh  justify-center items-center p-4">
          <div className="bg-white rounded-lg w-1/2 min-w-[400px] p-8">
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
              <div className="flex flex-col">
                <input
                  placeholder="Name"
                  {...register("name", { required: true })}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-black transition-colors"
                />
                <span className="text-red-500 text-sm h-5">{isSubmitted && errors.name ? "Name is required" : ""}</span>
              </div>

              <div className="flex flex-col">
                <input
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Entered value does not match email format"
                    }
                  })}
                  placeholder="Email"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-black transition-colors"
                />
                <span className="text-red-500 text-sm h-5">{isSubmitted && errors.email ? (errors.email.message || "Email is required") : ""}</span>
              </div>

              <div className="flex flex-col">
                <label className="mb-1">Idea you want to complaint about</label>
                <textarea
                  {...register("idea")}
                  rows={3}
                  className="w-full px-4 pt-1 pb-3 border-0 rounded-md focus:outline-none transition-colors resize-none"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1">Reason for the complaint</label>
                <textarea
                  {...register("reason")}
                  rows={3}
                  className="w-full px-4 pt-1 pb-3 border-0 rounded-md focus:outline-none transition-colors resize-none"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1">IP rights or other rights on which you base your complaint</label>
                <textarea
                  {...register("rights")}
                  rows={3}
                  className="w-full px-4 pt-1 pb-3 border-0 rounded-md focus:outline-none transition-colors resize-none"
                />
              </div>

              {status === 'sent' ? (
                <div className="w-full py-3 mt-2 text-blue-600 text-3xl font-medium text-center">
                  [ MESSAGE SENT ]
                </div>
              ) : status === 'error' ? (
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 mt-2 bg-transparent text-blue-600 text-3xl font-medium cursor-pointer mouse2 transition-opacity disabled:opacity-50"
                >
                  [ TRY AGAIN ]
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 mt-2 bg-transparent text-blue-600 text-3xl font-medium cursor-pointer mouse2 transition-opacity disabled:opacity-50"
                >
                  {loading ? '[ SENDING... ]' : '[ SEND ]'}
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    );
}

export default Contact
